module.exports = __webpack_public_path__ + "static/media/opera_logo.6de03df6.svg";